var _path;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgTransfer = function SvgTransfer(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8745 4.56686C10.6563 4.74146 10.3329 4.58606 10.3329 4.30659V3.00012H2.33294C1.96476 3.00012 1.66627 2.70164 1.66627 2.33345C1.66627 1.96526 1.96476 1.66678 2.33294 1.66678H10.3329V0.360329C10.3329 0.0808219 10.6563 -0.0745648 10.8745 0.100035L13.3409 2.07316C13.5077 2.2066 13.5077 2.4603 13.3409 2.59374L10.8745 4.56686ZM3.12472 9.90019C3.34297 10.0748 3.66628 9.91939 3.66628 9.63992V8.33346H11.6663C12.0345 8.33346 12.3329 8.03499 12.3329 7.66679C12.3329 7.29859 12.0345 7.00012 11.6663 7.00012H3.66628V5.69366C3.66628 5.41419 3.34297 5.25879 3.12472 5.43339L0.658308 7.40652C0.491501 7.53992 0.491501 7.79366 0.658308 7.92706L3.12472 9.90019Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransfer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Transfer.189dc79d.svg";
export { ForwardRef as ReactComponent };